export const calculationStatusNames = {
    "1": "New",
    "10": "Waiting",
    "11": "DWaiting",
    "2": "Running",
    "0": "Done",
    "-1": "Failed",
    "5": "Terminated",
};

export const calculationStatusIcons = {
    "1": ["hourglass-start", "#cccccc"],
    "10": ["hourglass-start", "#cccccc"],
    "11": ["hourglass-start", "#cccccc"],
    "2": ["spinner", "#225378"],
    "0": ["check", "#388E61"],
    "-1": ["times", "#DE350B"],
    "5": ["times", "#333333"],
};

export const jobStatusNames = {
    "1": "New",
    "3": "In progress",
    "-1": "Failed",
    "5": "Done",
};

// FIXME rename to publicUrl
export const clientUrlPrefix = process.env.PUBLIC_URL;

export const toolName = "FireProt";
export const toolSlug = "fireprot";
export const toolTitle = "Computational design of stable proteins";
export const toolVersion = process.env.REACT_APP_VERSION.match(/^\d+\.\d+/)[0];
export const toolKeywords = "protein engineering, thermostable proteins, multiple-point mutants, protein stability";
export const toolDescription = `${toolName}: ${toolTitle}`;
export const toolEmail = "fireprot@sci.muni.cz";

export const extraJobs = Number(process.env.REACT_APP_EXTRA_JOBS || "0");
export const extraVisitors = Number(process.env.REACT_APP_EXTRA_VISITORS || "0");

export const examplePDB = "4e46";
export const exampleSeq = "MSEIGTGFPFDPHYVEVLGERMHYVDVGPRDGTPVLFLHGNPTSSYLWRNIIPHVAPSHRCIAPDLIGMGKSDKPDLDYFFDDHVRYLDAFIEALGLEEVVLVIHDWGSALGFHWAKRNPERVKGIACMEFIRPIPTWDEWPEFARETFQAFRTADVGRELIIDQNAFIEGALPKCVVRPLTEVEMDHYREPFLKPVDREPLWRFPNELPIAGEPANIVALVEAYMNWLHQSPVPKLLFWGTPGVLIPPAEAARLAESLPNCKTVDIGPGLHYLQEDNPDLIGSEIARWLPALHHH";
export const exampleID = process.env.REACT_APP_EXAMPLE_ID;
